import { Action, createReducer, on } from '@ngrx/store';
import { commonCieActions } from './cie.action';
import { CommonCieState, commonCieIS } from './cie.state';

const commonCieRegister = createReducer(
  commonCieIS,
  on(commonCieActions.setResultAction, (state, result) => ({
    ...state,
    result,
  })),

  on(commonCieActions.setAllDefaultAction, () => commonCieIS)
);

export function commonCieReducer(state: CommonCieState, action: Action): any {
  return commonCieRegister(state, action);
}
